<template>
  <main-layout>
    <div class="container has-text-white">
      <H1 class="pageTitle"><b>404</b> The page you requested does not exist.</H1>
      <div class="top40 is-size-2 has-text-white"><b>Were you trying to use a slink?</b></div>
      <div class="top20 is-size-5 band has-background-darkTurk">Make sure to enter <b class="has-text-yell">"slink.com/"</b> followed by the <b class="has-text-yell">slink</b> into your browser address bar.</div>
      <div class="top20 has-text-white is-size-4">&nbsp;&nbsp;&nbsp;You are currently on the <b>Slink</b> website, which is on <b>site.slink.com</b></div>
      <div class="top60">
        <img src="@/assets/img/chevronsY.png" />
      </div>
     
    </div>
  </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'

export default {
  components: {
    MainLayout
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/p404.vue